import React from 'react';
import { useTranslation } from 'react-i18next';
import { validLanguages } from '../../../shared/data/languages';
export const LanguageDropdown = ({
  value,
  setValue
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("select", {
    value: value,
    onChange: ({
      target
    }) => setValue(target.value)
  }, validLanguages.map(language => /*#__PURE__*/React.createElement("option", {
    key: language,
    value: language
  }, t("translation.language_" + language))));
};